import FJAppLeft from '../../../FJMainPreview/FJAppLeft/FJAppLeft.jsx';
import PropTypes from 'prop-types';
import styles from './FJTextToSpeechLeft.module.less';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller.jsx';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJAvatarAudioPlay from '../../../../common/components/audio/FJAvatarAudioPlay/FJAvatarAudioPlay.jsx';
import FJArrowIcon from '../../../../assets/svg/ttv/arrow-down.svg?react';
import FJVoiceStyleSelect from './FJVoiceStyleSelect.jsx';
import FJSliderSet from '../../../../common/components/FJSliderSet/FJSliderSet.jsx';
import FJVoiceRecentlyList from './FJVoiceRecentlyList.jsx';
import FJConstant from '../../../../constants/FJConstant.js';
import classNames from 'classnames';
import FJTextWithEllipsis from '../../../../common/components/FJTextWithEllipsis/FJTextWithEllipsis.jsx';

const FJTextToSpeechLeft = props => {
    const {
        currentVoiceFromType,
        currentAvatarUrl,
        currentVoiceUrl,
        currentName,
        currentCountryInfo,
        currentSpeed,
        currentStyle,
        currentPitch,
        recentUseVoiceList,
        onChangeStyle,
        onChangeSpeed,
        onChangePitch,
        currentStyleList,
        openLibraryModal,
        isDisabled = false,
        onUse,
    } = props;
    return (
        <FJAppLeft style={{ padding: 0, width: '380px' }}>
            <FJVerticalScroller className={classNames(styles.scroll_box)}>
                <div className={classNames(styles.content, isDisabled ? styles.disabled : '')}>
                    <div className={styles.title}>{FJLocalStore._('voice-info')}</div>
                    <div className={styles.voice_item} onClick={openLibraryModal}>
                        <div className={styles.item_left}>
                            <FJAvatarAudioPlay audioUrl={currentVoiceUrl} imgUrl={currentAvatarUrl} />
                            <div className={styles.desc_box}>
                                <FJTextWithEllipsis className={styles.name} text={currentName} />
                                <FJTextWithEllipsis
                                    className={styles.country}
                                    text={FJLocalStore._(currentCountryInfo.languageKey) || currentCountryInfo.showLang}
                                />
                            </div>
                        </div>
                        <FJArrowIcon className={styles.icon} />
                    </div>
                    {currentVoiceFromType === FJConstant.MICROSOFT && (
                        <>
                            <div className={styles.title}>{FJLocalStore._('voice-setting')}</div>
                            {currentStyleList.length > 1 && (
                                <>
                                    <div className={styles.sub_title}>{FJLocalStore._('voice-style')}</div>
                                    <FJVoiceStyleSelect
                                        value={currentStyle}
                                        onChange={onChangeStyle}
                                        list={currentStyleList}
                                    />
                                </>
                            )}
                            <FJSliderSet
                                text={FJLocalStore._('speed')}
                                className={styles.slide}
                                labelClassName={styles.label}
                                value={currentSpeed}
                                onChange={onChangeSpeed}
                                min={0}
                                max={3}
                                step={0.1}
                                defaultValue={1}
                                digits={1}
                            />
                            <FJSliderSet
                                text={FJLocalStore._('pitch')}
                                className={styles.slide}
                                labelClassName={styles.label}
                                value={currentPitch}
                                onChange={onChangePitch}
                                min={0}
                                max={2}
                                step={0.1}
                                defaultValue={1}
                                digits={1}
                            />
                        </>
                    )}
                    {recentUseVoiceList && !!recentUseVoiceList.length && (
                        <FJVoiceRecentlyList list={recentUseVoiceList} onUse={onUse} />
                    )}
                </div>
            </FJVerticalScroller>
        </FJAppLeft>
    );
};

FJTextToSpeechLeft.propTypes = {
    currentVoiceFromType: PropTypes.string,
    currentAvatarUrl: PropTypes.string,
    currentVoiceUrl: PropTypes.string,
    currentName: PropTypes.string,
    currentSpeed: PropTypes.number,
    currentStyle: PropTypes.string,
    currentPitch: PropTypes.number,
    recentUseVoiceList: PropTypes.array,
    onChangeStyle: PropTypes.func,
    onChangeSpeed: PropTypes.func,
    onChangePitch: PropTypes.func,
    currentCountryInfo: PropTypes.object,
    currentStyleList: PropTypes.array,
    openLibraryModal: PropTypes.func,
    isDisabled: PropTypes.bool,
    onUse: PropTypes.func,
};
export default FJTextToSpeechLeft;
